import React from "react";

import HOW_WORKS from "../assets/how_works.png";
import "../css/Home.css";

function HowDoesItWork() {
  return (
    <div className="th-how__works">
      <span className="th-hero__text th-hero__text__title th-hero__text__sub">
        How Does it
        <span className="th-hero__text__subtitle"> Work?</span>
      </span>
      <div className="w-full flex flex-column justify-content-between lg:flex-row">
        <div className="th-how__works__container">
          <div className="th-how__works__section">
            <div className="th-how__works__svg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="48"
                height="48"
                viewBox="0 0 48 48"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M7.63672 19.3281C7.63672 18.4997 8.3083 17.8281 9.13672 17.8281H41.2196C42.048 17.8281 42.7196 18.4997 42.7196 19.3281C42.7196 20.1566 42.048 20.8282 41.2196 20.8282H9.13672C8.3083 20.8282 7.63672 20.1566 7.63672 19.3281Z"
                  fill="#383838"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M32.4453 4.5C33.2737 4.5 33.9453 5.17158 33.9453 6V11.9235C33.9453 12.7519 33.2737 13.4235 32.4453 13.4235C31.6169 13.4235 30.9453 12.7519 30.9453 11.9235V6C30.9453 5.17158 31.6169 4.5 32.4453 4.5Z"
                  fill="#383838"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M17.9062 4.5C18.7347 4.5 19.4062 5.17158 19.4062 6V11.9235C19.4062 12.7519 18.7347 13.4235 17.9062 13.4235C17.0778 13.4235 16.4062 12.7519 16.4062 11.9235V6C16.4062 5.17158 17.0778 4.5 17.9062 4.5Z"
                  fill="#383838"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M10.2463 9.90513C12.0844 8.15795 14.6426 7.34375 17.5562 7.34375H32.797C35.7172 7.34375 38.2768 8.15731 40.1122 9.90647C41.9588 11.6665 42.8772 14.188 42.8688 17.2026C42.8688 17.2022 42.8688 17.2031 42.8688 17.2026V33.6274C42.8688 36.6424 41.9462 39.1662 40.0994 40.9292C38.2632 42.682 35.7038 43.5008 32.7814 43.5008H17.5562C14.6336 43.5008 12.0721 42.6644 10.2358 40.8846C8.39209 39.0976 7.46875 36.5432 7.46875 33.4912V17.1997C7.46875 14.1833 8.39671 11.6633 10.2463 9.90513ZM12.3133 12.0795C11.1909 13.1463 10.4687 14.8043 10.4687 17.1997V33.4912C10.4687 35.9366 11.1955 37.637 12.3238 38.7304C13.4594 39.8312 15.1917 40.5008 17.5562 40.5008H32.7814C35.1616 40.5008 36.896 39.8396 38.0278 38.7592C39.149 37.689 39.8688 36.026 39.8688 33.6274V17.1997V17.1954C39.8758 14.7989 39.1596 13.1429 38.0424 12.0782C36.9136 11.0023 35.1794 10.3437 32.797 10.3437H17.5562C15.1827 10.3437 13.4472 11.0017 12.3133 12.0795Z"
                  fill="#383838"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M25.168 24.1543C25.9966 24.1543 26.668 24.8259 26.668 25.6543V34.6545C26.668 35.4829 25.9966 36.1545 25.168 36.1545C24.3396 36.1545 23.668 35.4829 23.668 34.6545V25.6543C23.668 24.8259 24.3396 24.1543 25.168 24.1543Z"
                  fill="#383838"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M19.168 30.1543C19.168 29.3259 19.8395 28.6543 20.6679 28.6543H29.6681C30.4965 28.6543 31.1681 29.3259 31.1681 30.1543C31.1681 30.9829 30.4965 31.6543 29.6681 31.6543H20.6679C19.8395 31.6543 19.168 30.9829 19.168 30.1543Z"
                  fill="#383838"
                />
              </svg>
            </div>
            <div className="th-how__works__data">
              <span className="th-how__works__data__title">Create</span>
              <span className="th-how__works__data__subtitle">
                Create an Event (or) Select from Packages
              </span>
            </div>
          </div>
          <div className="th-how__works__seperator"></div>
          <div className="th-how__works__section">
            <div className="th-how__works__svg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="48"
                height="48"
                viewBox="0 0 48 48"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M19.754 28.912L19.9922 28.9121L20.5201 28.9135C25.004 28.9375 35.508 29.3451 35.508 36.274C35.508 42.6982 26.8812 43.5566 20.1708 43.589L18.9879 43.5885C14.504 43.5645 4 43.1571 4 36.23C4 29.67 12.99 28.912 19.754 28.912ZM19.754 31.912C11.292 31.912 7 33.366 7 36.23C7 39.122 11.292 40.59 19.754 40.59C28.216 40.59 32.508 39.136 32.508 36.274C32.508 33.378 28.216 31.912 19.754 31.912ZM38.4082 15.8374C39.2362 15.8374 39.9082 16.5094 39.9082 17.3374L39.908 19.846L42.5 19.8476C43.328 19.8476 44 20.5196 44 21.3476C44 22.1756 43.328 22.8476 42.5 22.8476L39.908 22.846L39.9082 25.3594C39.9082 26.1874 39.2362 26.8594 38.4082 26.8594C37.5802 26.8594 36.9082 26.1874 36.9082 25.3594L36.908 22.846L34.32 22.8476C33.492 22.8476 32.82 22.1756 32.82 21.3476C32.82 20.5196 33.492 19.8476 34.32 19.8476L36.908 19.846L36.9082 17.3374C36.9082 16.5094 37.5802 15.8374 38.4082 15.8374ZM19.754 4C25.62 4 30.39 8.772 30.39 14.636C30.39 20.5 25.62 25.272 19.754 25.272H19.692C16.854 25.262 14.194 24.148 12.2 22.14C10.204 20.13 9.11 17.462 9.11993 14.63C9.11993 8.772 13.89 4 19.754 4ZM19.754 7C15.546 7 12.1199 10.426 12.1199 14.636C12.112 16.674 12.896 18.584 14.326 20.026C15.758 21.466 17.666 22.264 19.698 22.272L19.754 23.754V22.272C23.964 22.272 27.39 18.846 27.39 14.636C27.39 10.426 23.964 7 19.754 7Z"
                  fill="#383838"
                />
              </svg>
            </div>
            <div className="th-how__works__data">
              <span className="th-how__works__data__title">Invite</span>
              <span className="th-how__works__data__subtitle">
                Invite Friends/Family via social media
              </span>
            </div>
          </div>
          <div className="th-how__works__seperator"></div>
          <div className="th-how__works__section">
            <div className="th-how__works__svg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="48"
                height="48"
                viewBox="0 0 48 48"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M19.754 28.912L19.9922 28.9121L20.5201 28.9135C25.004 28.9375 35.508 29.3451 35.508 36.274C35.508 42.6982 26.8812 43.5566 20.1708 43.589L18.9879 43.5885C14.504 43.5645 4 43.1571 4 36.23C4 29.67 12.99 28.912 19.754 28.912ZM19.754 31.912C11.292 31.912 7 33.366 7 36.23C7 39.122 11.292 40.59 19.754 40.59C28.216 40.59 32.508 39.136 32.508 36.274C32.508 33.378 28.216 31.912 19.754 31.912ZM38.4082 15.8374C39.2362 15.8374 39.9082 16.5094 39.9082 17.3374L39.908 19.846L42.5 19.8476C43.328 19.8476 44 20.5196 44 21.3476C44 22.1756 43.328 22.8476 42.5 22.8476L39.908 22.846L39.9082 25.3594C39.9082 26.1874 39.2362 26.8594 38.4082 26.8594C37.5802 26.8594 36.9082 26.1874 36.9082 25.3594L36.908 22.846L34.32 22.8476C33.492 22.8476 32.82 22.1756 32.82 21.3476C32.82 20.5196 33.492 19.8476 34.32 19.8476L36.908 19.846L36.9082 17.3374C36.9082 16.5094 37.5802 15.8374 38.4082 15.8374ZM19.754 4C25.62 4 30.39 8.772 30.39 14.636C30.39 20.5 25.62 25.272 19.754 25.272H19.692C16.854 25.262 14.194 24.148 12.2 22.14C10.204 20.13 9.11 17.462 9.11993 14.63C9.11993 8.772 13.89 4 19.754 4ZM19.754 7C15.546 7 12.1199 10.426 12.1199 14.636C12.112 16.674 12.896 18.584 14.326 20.026C15.758 21.466 17.666 22.264 19.698 22.272L19.754 23.754V22.272C23.964 22.272 27.39 18.846 27.39 14.636C27.39 10.426 23.964 7 19.754 7Z"
                  fill="#383838"
                />
                <rect x="33" y="14" width="11" height="13" fill="white" />
              </svg>
            </div>
            <div className="th-how__works__data">
              <span className="th-how__works__data__title">
                Select Provider
              </span>
              <span className="th-how__works__data__subtitle">
                Invite Friends/Family via WhatsApp
              </span>
            </div>
          </div>
          <div className="th-how__works__seperator"></div>
          <div className="th-how__works__section">
            <div className="th-how__works__svg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="48"
                height="48"
                viewBox="0 0 48 48"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M33.284 6C39.898 6 45.278 11.38 45.278 17.996V32.35C45.278 38.964 39.898 44.346 33.284 44.346H15.996C9.382 44.346 4 38.964 4 32.35V17.996C4 11.38 9.382 6 15.996 6H33.284ZM33.284 9H15.996C11.036 9 7 13.036 7 17.996V32.35C7 37.31 11.036 41.346 15.996 41.346H33.284C38.244 41.346 42.278 37.31 42.278 32.35V31.79L35.6822 31.7912C31.8882 31.7912 28.8002 28.7052 28.7982 24.9132C28.7982 21.1172 31.8862 18.0292 35.6822 18.0272L42.278 18.026V17.996C42.278 13.036 38.244 9 33.284 9ZM42.278 21.026L35.6822 21.0272C33.5402 21.0292 31.7982 22.7712 31.7982 24.9112C31.7982 27.0492 33.5422 28.7912 35.6822 28.7912L42.278 28.79V21.026ZM36.5974 23.2872C37.4254 23.2872 38.0974 23.9592 38.0974 24.7872C38.0974 25.6152 37.4254 26.2872 36.5974 26.2872H35.9734C35.1454 26.2872 34.4734 25.6152 34.4734 24.7872C34.4734 23.9592 35.1454 23.2872 35.9734 23.2872H36.5974ZM25.37 15.0762C26.198 15.0762 26.87 15.7482 26.87 16.5762C26.87 17.4042 26.198 18.0762 25.37 18.0762H14.572C13.744 18.0762 13.072 17.4042 13.072 16.5762C13.072 15.7482 13.744 15.0762 14.572 15.0762H25.37Z"
                  fill="#383838"
                />
              </svg>
            </div>
            <div className="th-how__works__data">
              <span className="th-how__works__data__title">Pay & Confirm</span>
              <span className="th-how__works__data__subtitle">
                Pay Online & Confirm Order
              </span>
            </div>
          </div>
        </div>
        <div className="flex mt-5 justify-content-center lg:mt-0">
          <img
            src={HOW_WORKS}
            className="th-works__image"
            alt="How does it work?"
          />
        </div>
      </div>
    </div>
  );
}

export default HowDoesItWork;
